import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import logoIcon from './assets/images/logo.png';
import reportWebVitals from './reportWebVitals';

// Replace default React favicon with company logo
const faviconLink = document.querySelector("link[rel*='icon']") || document.createElement('link');
faviconLink.type = 'image/png';
faviconLink.rel = 'icon';
faviconLink.href = logoIcon;
document.head.appendChild(faviconLink);

const root= ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
